import { render } from "./StepCheck.vue?vue&type=template&id=d5fcc332&scoped=true"
import script from "./StepCheck.vue?vue&type=script&lang=js"
export * from "./StepCheck.vue?vue&type=script&lang=js"

import "./StepCheck.vue?vue&type=style&index=0&id=d5fcc332&scoped=true&lang=css"

import exportComponent from "C:\\Users\\ma-dg\\Desktop\\wa\\ask_wizard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d5fcc332"]])

export default __exports__